import {combineReducers} from 'redux'
import {createPivotTableReducer} from 'reducers/pivotTable'
import {
  getPivotTableTotalCostReducer,
  getPivotTableTotalMarginReducer,
  getPivotTableTotalPriceReducer,
} from 'helpers/pivotTable'
import types from 'actions/types'
import {get} from 'lodash'

export const salesContextSalesAnalysisQuotesViewPivotTableKey = 'salesContext.salesAnalysisView.quoteDataSource.quotes'

export const layoutId = (state = null, action) => {
  switch (action.type) {
    case types.SALES_UPDATE_SALES_ANALYSIS_QUOTING_FILTERS:
      return get(action, 'filters.layoutId', state)
    default:
      return state
  }
}

export const isOverriding = (state = false, action) => {
  const isCorrectKey = action.key === salesContextSalesAnalysisQuotesViewPivotTableKey
  switch (action.type) {
    case types.SALES_UPDATE_SALES_ANALYSIS_QUOTING_FILTERS:
      return get(action, 'filters.isOverriding', state)
    case types.SALES_UPDATE_SALES_ANALYSIS_QUOTING_IS_OVERRIDING:
      return get(action, 'isOverriding', state)
    case types.PIVOT_TABLE_SET_GROUPS:
      return isCorrectKey
    case types.PIVOT_TABLE_SET_VISIBLE_COLUMNS:
      return isCorrectKey
    case types.PIVOT_TABLE_SORT:
      return isCorrectKey
    default:
      return state
  }
}

export const statusTypes = (state = [], action) => {
  switch (action.type) {
    case types.SALES_UPDATE_SALES_ANALYSIS_QUOTING_FILTERS:
      return get(action, 'filters.statusTypes', state)
    default:
      return state
  }
}

export const companies = (state = [], action) => {
  switch (action.type) {
    case types.SALES_UPDATE_SALES_ANALYSIS_QUOTING_FILTERS:
      return get(action, 'filters.companies', state)
    default:
      return state
  }
}

export const contacts = (state = [], action) => {
  switch (action.type) {
    case types.SALES_UPDATE_SALES_ANALYSIS_QUOTING_FILTERS:
      return get(action, 'filters.contacts', state)
    default:
      return state
  }
}

export const userTypes = (state = ['personSalesman'], action) => {
  switch (action.type) {
    case types.SALES_UPDATE_SALES_ANALYSIS_QUOTING_FILTERS:
      return get(action, 'filters.userTypes', state)
    default:
      return state
  }
}

export const showDormants = (state = false, action) => {
  switch (action.type) {
    case types.SALES_UPDATE_SALES_ANALYSIS_QUOTING_FILTERS:
      return get(action, 'filters.showDormants', state)
    default:
      return state
  }
}

export const timeKey = (state = null, action) => {
  switch (action.type) {
    case types.SALES_UPDATE_SALES_ANALYSIS_QUOTING_FILTERS:
      return get(action, 'filters.timeKey', state)
    default:
      return state
  }
}

export const dateTypes = (state = [], action) => {
  switch (action.type) {
    case types.SALES_UPDATE_SALES_ANALYSIS_QUOTING_FILTERS:
      return get(action, 'filters.dateTypes', state)
    default:
      return state
  }
}

export const targetStart = (state = null, action) => {
  switch (action.type) {
    case types.SALES_UPDATE_SALES_ANALYSIS_QUOTING_FILTERS:
      return get(action, 'filters.targetStart', state)
    default:
      return state
  }
}

export const targetEnd = (state = null, action) => {
  switch (action.type) {
    case types.SALES_UPDATE_SALES_ANALYSIS_QUOTING_FILTERS:
      return get(action, 'filters.targetEnd', state)
    default:
      return state
  }
}

export const orderTypeId = (state = null, action) => {
  switch (action.type) {
    case types.SALES_UPDATE_SALES_ANALYSIS_QUOTING_FILTERS:
      return get(action, 'filters.orderTypeId', state)
    default:
      return state
  }
}

const total = (state = null, action) => {
  return getPivotTableTotalPriceReducer(state, action, salesContextSalesAnalysisQuotesViewPivotTableKey)
}

const totalCostSum = (state = null, action) => {
  return getPivotTableTotalCostReducer(state, action, salesContextSalesAnalysisQuotesViewPivotTableKey)
}

const totalMargin = (state = null, action) => {
  return getPivotTableTotalMarginReducer(state, action, salesContextSalesAnalysisQuotesViewPivotTableKey)
}

export default combineReducers ({
  layoutId,
  isOverriding,
  total,
  totalCostSum,
  totalMargin,
  statusTypes,
  companies,
  contacts,
  userTypes,
  showDormants,
  timeKey,
  dateTypes,
  targetStart,
  targetEnd,
  orderTypeId,
  quotes: createPivotTableReducer({key: salesContextSalesAnalysisQuotesViewPivotTableKey, defaultSortColumn: 'createdDate', defaultSortDirection: 'desc'}),
})
